<template>
  <div>
    <div class="pa-0 ma-0">
      <div class="body-overall">
        <v-row style="padding-top:64px!important"></v-row>
        <div :class="getGextPanel" class="pt-6" style="margin:0px!important;">
          <div class="fonts-white container pl-0 pr-1">
            <div class="overlay-grey-web">
              <!-- Header Section -->
              <div class="api-header">
                <div class="header-content">
                  <v-icon class="header-icon">mdi-api</v-icon>
                  <h1 class="header-title">Dashboard</h1>
                </div>
                
                <!-- Quick Actions -->
                <div class="quick-actions">
                  <v-btn
                    variant="outlined"
                    prepend-icon="mdi-book-open-variant"
                    @click="handleClickMenu('apidoc')"
                    class="action-link-btn"
                  >
                    Documentation
                  </v-btn>
                  <v-btn
                    variant="outlined"
                    prepend-icon="mdi-cash-plus"
                    @click="handleClickMenu('payment')"
                    class="action-link-btn"
                  >
                    Buy Credits
                  </v-btn>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- API Key Section -->
              <div v-if="this.user" class="api-section">
                <h2 class="section-title">
                  <v-icon left>mdi-key</v-icon>
                  API Key
                </h2>
                
                <div class="api-key-card">
                  <div class="key-info">
                    <div class="key-label">
                      <v-icon size="18" class="mr-2">mdi-shield-key</v-icon>
                      <span>Your API Key</span>
                    </div>
                    <div class="key-value-wrapper">
                      <v-text-field
                        class="api-key-field"
                        :model-value="getCreatorVer()"
                        readonly
                        hide-details
                        variant="outlined"
                        density="comfortable"
                      >
                        <template v-slot:append-inner>
                          <v-btn
                            icon
                            size="small"
                            variant="text"
                            @click="copyApiKey"
                          >
                            <v-icon size="18">mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </div>
                    <div class="key-hint">
                      <v-icon size="14">mdi-information-outline</v-icon>
                      <span>Keep your API key secure. You can regenerate it by clicking the refresh button.</span>
                    </div>
                  </div>
                  <div class="key-actions">
                    <v-btn
                      variant="outlined"
                      prepend-icon="mdi-refresh"
                      @click="generatekey()"
                      :disabled="true"
                      class="regenerate-btn"
                    >
                      Regenerate Key
                    </v-btn>
                  </div>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Credits Section -->
              <div v-if="this.cryptoUserData" class="api-section">
                <h2 class="section-title">
                  <v-icon left>mdi-coin</v-icon>
                  API Credits
                </h2>

                <div class="credits-cards-grid">
                  <div class="credit-card credit-card-primary">
                    <div class="credit-icon-wrapper">
                      <v-icon size="32">mdi-wallet</v-icon>
                    </div>
                    <div class="credit-content">
                      <span class="credit-label">Available Credits</span>
                      <span class="credit-value">{{ formatNumber(this.cryptoUserData.tokens - this.cryptoUserData.tokens_vested - this.cryptoUserData.in_transfer) }}</span>
                      <span class="credit-hint">Ready to use for API calls</span>
                    </div>
                  </div>

                  <div class="credit-card credit-card-secondary">
                    <div class="credit-icon-wrapper">
                      <v-icon size="32">mdi-clock-outline</v-icon>
                    </div>
                    <div class="credit-content">
                      <span class="credit-label">Staked Credits</span>
                      <span class="credit-value">{{ formatNumber(this.cryptoUserData.tokens_vested) }}</span>
                      <span class="credit-hint">Currently locked</span>
                    </div>
                  </div>

                  <div class="credit-card credit-card-tertiary">
                    <div class="credit-icon-wrapper">
                      <v-icon size="32">mdi-transfer</v-icon>
                    </div>
                    <div class="credit-content">
                      <span class="credit-label">In Transfer</span>
                      <span class="credit-value">{{ formatNumber(this.cryptoUserData.in_transfer) }}</span>
                      <span class="credit-hint">Pending transactions</span>
                    </div>
                  </div>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Usage Statistics Section -->
              <div class="api-section">
                <h2 class="section-title">
                  <v-icon left>mdi-chart-line</v-icon>
                  Usage Statistics
                </h2>

                <!-- Date Range Filter -->
                <div class="usage-filters">
                  <v-checkbox
                    v-model="allStats"
                    color="white"
                    class="all-stats-checkbox"
                    hide-details
                  >
                    <template v-slot:label>
                      <span class="checkbox-label">Show All Data</span>
                    </template>
                  </v-checkbox>

                  <div class="date-range-picker">
                    <v-menu
                      :disabled="allStats"
                      v-model="menuFrom"
                      :close-on-content-click="false"
                      transition="scale-transition"
                    >
                      <template v-slot:activator="{ props }">
                        <v-text-field
                          v-model="formattedDateFrom"
                          label="From Date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="props"
                          :disabled="allStats"
                          class="date-field"
                          variant="outlined"
                          density="comfortable"
                          hide-details
                        >
                          <template v-slot:append-inner>
                            <v-btn
                              v-if="!allStats"
                              icon
                              size="x-small"
                              variant="text"
                              @click.stop="menuFrom = false"
                            >
                              <v-icon size="16">mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateFrom"
                        :max="dateTo"
                        @update:model-value="menuFrom = false"
                        color="white"
                        style="border:1px solid rgba(255,255,255,0.3);"
                      ></v-date-picker>
                    </v-menu>

                    <v-menu
                      :disabled="allStats"
                      v-model="menuTo"
                      :close-on-content-click="false"
                      transition="scale-transition"
                    >
                      <template v-slot:activator="{ props }">
                        <v-text-field
                          v-model="formattedDateTo"
                          label="To Date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="props"
                          :disabled="allStats"
                          class="date-field"
                          variant="outlined"
                          density="comfortable"
                          hide-details
                        >
                          <template v-slot:append-inner>
                            <v-btn
                              v-if="!allStats"
                              icon
                              size="x-small"
                              variant="text"
                              @click.stop="menuTo = false"
                            >
                              <v-icon size="16">mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateTo"
                        :min="dateFrom"
                        :max="new Date()"
                        @update:model-value="menuTo = false"
                        color="white"
                        style="border:1px solid rgba(255,255,255,0.3);"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </div>

                <!-- Empty State -->
                <div class="usage-empty-state">
                  <div class="empty-icon-wrapper">
                    <v-icon size="64" color="grey">mdi-chart-box-outline</v-icon>
                  </div>
                  <h3 class="empty-title">No Usage Data</h3>
                  <p class="empty-subtitle">
                    Start using the API to see your usage statistics here
                  </p>
                  <v-btn
                    variant="outlined"
                    prepend-icon="mdi-book-open-variant"
                    @click="handleClickMenu('apidoc')"
                    class="mt-4"
                  >
                    View Documentation
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-row
          :style="(this.isMobileXs || this.isMobilePlayer3) ? 'padding-top:170px!important' : 'padding-top:123px!important'"></v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { useMobile } from '../composables/useMobile.js'
import { useMobilePlayer3 } from '../composables/useMobilePlayer3.js'
import { useMobileXs } from '../composables/useMobileXs.js'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";


export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3();

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    return { isMobile, isMobileXs, notify, notifyError, isMobilePlayer3 }
  },
  name: 'Api',

  components: {

  },
  data: () => ({
    navbar: false,
    user: null,
    searchQuery: "",
    cryptoUserData: null,
    menuFrom: false,
    menuTo: false,
    dateFrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    dateTo: new Date(),
    allStats: true,

  }),
  mounted() {
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {

  },
  destroyed() {
  },
  watch: {
    '$store.state.user': function () {
      this.user = this.$store.getters.getUserData;
    },
    '$store.state.crypto_user_data': function() {
          this.cryptoUserData = this.$store.getters.getCryptoUserData;
      },
  },
  computed: {
    isfullScreen() {
      if (this.isMobile && this.isMobileXs) {
        return false;
      } else {
        return true;
      }
    },
    isLogged() {
      return this.$store.getters.getUserData != null
    },
    isDesktop() {
      if (!this.navbar) {
        return true;
      } else {
        return false;
      }
    },
    getGextPanel() {
      if (this.navbar) {
        if (this.isMobileXs) {
          return 'textPanelMobileXs'
        } else {
          return 'textPanelMobile';
        }
      } else return 'textPanel';
    },
    formattedDateFrom() {
      return this.dateFrom.toLocaleDateString();
    },
    formattedDateTo() {
      return this.dateTo.toLocaleDateString();
    },

  },
  created() {
    if (this.$store.getters.getUserData != null) {
      this.user = this.$store.getters.getUserData;

      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }

      this.$store.dispatch('getCryptoUserData',{ token: this.user.token
                                            }).then( response => {        
        this.cryptoUserData = this.$store.getters.getCryptoUserData;

      }).catch( error => {
        if (!error.response) {
          this.notifyError(
            "Network problem, please try again later.."
          );
        }
      })

    }
  },
  methods: {
    formatNumber(number) {
        let integer = parseInt(number);

        if (number == integer)
            return number;
        else {
            return parseFloat(number).toFixed(6).replace(/\.?0+$/, '');
        }
    },
    generatekey() {
      // Key generation
      this.notify('Key regeneration feature coming soon!');
    },
    getCreatorVer(){
        return 'No Key Available'
    },
    copyApiKey() {
      const key = this.getCreatorVer();
      if (key === 'No Key Available') {
        this.notifyError('No API key to copy');
        return;
      }
      navigator.clipboard.writeText(key).then(() => {
        this.notify('API Key copied to clipboard!');
      }).catch(() => {
        this.notifyError('Failed to copy API key');
      });
    },
    checkScreenSize() {
      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    },
    handleClickMenu(link) {
      if (link === 'apidoc') {
        window.location.href = 'https://docs.muzible.com/';
      } else if (link === 'payment') {
        this.$router.push({ name: 'payment' });
      } else if (link === 'TryVerse') {
        window.location.href = 'https://verse.muzible.com/';
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* API Header */
.api-header {
  margin-bottom: 32px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.header-icon {
  font-size: 48px !important;
  color: white;
}

.header-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.quick-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.action-link-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.action-link-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

/* Section */
.api-section {
  margin-bottom: 40px;
}

.section-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

/* API Key Card */
.api-key-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 24px;
  transition: all 0.3s ease;
}

.api-key-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.key-info {
  margin-bottom: 20px;
}

.key-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.key-value-wrapper {
  margin-bottom: 12px;
}

.api-key-field {
  font-family: 'Courier New', monospace !important;
}

:deep(.api-key-field .v-field) {
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 8px !important;
}

:deep(.api-key-field .v-field__input) {
  color: white !important;
  font-size: 14px !important;
  font-weight: 500;
}

.key-hint {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
}

.key-actions {
  display: flex;
  justify-content: flex-end;
}

.regenerate-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.regenerate-btn:not(:disabled):hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

/* Credits Cards */
.credits-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

@media (max-width: 768px) {
  .credits-cards-grid {
    grid-template-columns: 1fr;
  }
}

.credit-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.credit-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.credit-card:hover {
  transform: translateY(-4px);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

.credit-card:hover::before {
  opacity: 1;
}

.credit-card-primary {
  border-color: rgba(76, 175, 80, 0.3);
}

.credit-card-primary:hover {
  border-color: rgba(76, 175, 80, 0.6);
  box-shadow: 0 8px 32px rgba(76, 175, 80, 0.2);
}

.credit-card-primary::before {
  background: linear-gradient(90deg, transparent, rgba(76, 175, 80, 0.6), transparent);
}

.credit-card-secondary {
  border-color: rgba(255, 152, 0, 0.3);
}

.credit-card-secondary:hover {
  border-color: rgba(255, 152, 0, 0.6);
  box-shadow: 0 8px 32px rgba(255, 152, 0, 0.2);
}

.credit-card-secondary::before {
  background: linear-gradient(90deg, transparent, rgba(255, 152, 0, 0.6), transparent);
}

.credit-card-tertiary {
  border-color: rgba(33, 150, 243, 0.3);
}

.credit-card-tertiary:hover {
  border-color: rgba(33, 150, 243, 0.6);
  box-shadow: 0 8px 32px rgba(33, 150, 243, 0.2);
}

.credit-card-tertiary::before {
  background: linear-gradient(90deg, transparent, rgba(33, 150, 243, 0.6), transparent);
}

.credit-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  flex-shrink: 0;
}

.credit-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.credit-label {
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.credit-value {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: white;
  line-height: 1;
}

.credit-hint {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

/* Usage Filters */
.usage-filters {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
}

.all-stats-checkbox {
  margin-bottom: 16px;
}

:deep(.all-stats-checkbox .v-label) {
  color: white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500;
}

.checkbox-label {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: white;
}

.date-range-picker {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 600px) {
  .date-range-picker {
    grid-template-columns: 1fr;
  }
}

.date-field {
  font-family: "Darker Grotesque", sans-serif !important;
}

:deep(.date-field .v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

:deep(.date-field .v-field:hover:not(.v-field--disabled)) {
  border-color: rgba(255, 255, 255, 0.4) !important;
}

:deep(.date-field .v-field--focused) {
  border-color: rgba(255, 255, 255, 0.6) !important;
}

:deep(.date-field .v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
  font-family: "Darker Grotesque", sans-serif !important;
}

:deep(.date-field .v-field__input) {
  color: white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 500;
}

:deep(.date-field.v-field--disabled .v-field) {
  opacity: 0.5;
}

/* Empty State */
.usage-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 60px 20px;
  text-align: center;
}

.empty-icon-wrapper {
  margin-bottom: 24px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.empty-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin-bottom: 8px;
}

.empty-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 24px;
  max-width: 400px;
}

/* Animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.api-key-card,
.credit-card,
.usage-filters {
  animation: slideIn 0.4s ease forwards;
}

.credit-card:nth-child(1) { animation-delay: 0.05s; }
.credit-card:nth-child(2) { animation-delay: 0.1s; }
.credit-card:nth-child(3) { animation-delay: 0.15s; }

/* Override Vuetify */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-list-item:hover) > .v-list-item__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

/* Old styles cleanup */
@keyframes blink {
  0% { opacity: 1; }
  40% { opacity: 1; }
  60% { opacity: 0; }
  100% { opacity: 0; }
}

.blink {
  animation: blink 1.5s infinite both;
}
</style>